<app-product-variant-widget [baseProduct]="this.model"></app-product-variant-widget>